import { Injectable } from '@angular/core'
import { inject } from '@angular/core'
import { CanActivate, Router } from '@angular/router'

import { FrameDetectionService } from '../services/frame-detection.service'

@Injectable({
  providedIn: 'root',
})
export class IframeGuard implements CanActivate {
  // Inject services using Angular's `inject()` function
  private frameDetectionService = inject(FrameDetectionService)
  private router = inject(Router)

  // Guard method that determines whether navigation is allowed
  canActivate(): boolean {
    const isIframe = this.frameDetectionService.isIframe()

    // If the app is running inside an iframe, block access and redirect to 404
    if (isIframe) {
      this.router.navigate(['/404'])
      return false
    }

    // Otherwise, allow navigation
    return true
  }
}
